<form [formGroup]="configurationFormSftp">
  <div class="form-row row">
    <div class="form-group col-12">

      <div innerHTML="{{'i18n.domain.import-configuration.edit.sftp'| translate: {URLParam: sftpServerUrl} }}"></div>

    </div>
  </div>
</form>
